import { render } from "./languageTranslation.vue?vue&type=template&id=27f31f57&scoped=true"
import script from "./languageTranslation.vue?vue&type=script&lang=js"
export * from "./languageTranslation.vue?vue&type=script&lang=js"

import "./languageTranslation.vue?vue&type=style&index=0&id=27f31f57&lang=scss&scoped=true"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f31f57"]])

export default __exports__